import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { LOCAL_STORAGE_GRETA_AI_CHAT_DRAFTS_KEY } from '../../../../constants/storage'
import { isValueObjectType, isValueStringType } from '../../../../utils/common'
import {
  getStorageSerializedItem,
  setStorageSerializedItem,
} from '../../../../utils/storage'

import {
  GRETA_DRAFT_TTL_MS,
  GRETA_MAX_DRAFTS,
} from './useGretaAIChatDrafts.constants'

export function getGretaAIChatDraftText(entries, key) {
  return entries.find(entry => entry.key === key)?.text ?? EMPTY_STRING
}

export function removeGretaAIChatDraft(entries, key) {
  return entries.filter(entry => entry.key !== key)
}

// Length, not trim: whitespace being typed must survive in the controlled input.
export function upsertGretaAIChatDraft(entries, key, text, now) {
  const next = removeGretaAIChatDraft(entries, key)

  if (text.length > 0) {
    next.push({ key, text, updatedAt: now })
  }

  while (next.length > GRETA_MAX_DRAFTS) {
    next.shift()
  }

  return next
}

export function pruneGretaAIChatDrafts(entries, now) {
  if (!Array.isArray(entries)) {
    return EMPTY_LIST
  }

  return entries.filter(
    entry =>
      entry?.key &&
      isValueStringType(entry.text) &&
      now - entry.updatedAt < GRETA_DRAFT_TTL_MS
  )
}

export function readGretaAIChatUserDrafts(userId) {
  const store = getStorageSerializedItem(LOCAL_STORAGE_GRETA_AI_CHAT_DRAFTS_KEY)

  return pruneGretaAIChatDrafts(store?.[userId], Date.now())
}

export function writeGretaAIChatUserDrafts(userId, entries) {
  const store = getStorageSerializedItem(LOCAL_STORAGE_GRETA_AI_CHAT_DRAFTS_KEY)

  setStorageSerializedItem(LOCAL_STORAGE_GRETA_AI_CHAT_DRAFTS_KEY, {
    ...(isValueObjectType(store) ? store : null),
    [userId]: entries,
  })
}
